import { styled } from "@mui/material/styles";
import { colors } from "../../../../../theme/colors";
import { Box, List, ListItem, Avatar, ListItemText, InputBase } from "@mui/material";

export const ListContainer = styled(Box)(({ theme }) => ({
  width: 350,
  minWidth: 320,
  maxWidth: 380,
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#ffffff",
  borderRight: `1px solid ${colors.border.light}`,
  height: "100%",
  boxSizing: "border-box",
}));

export const ListHeaderContainer = styled(Box)(({ theme }) => ({
  padding: "16px 16px 12px 16px",
  borderBottom: `1px solid ${colors.border.light}`,
  backgroundColor: "#ffffff",
}));

export const HeaderTitleRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "12px",
});

export const SearchBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: "#f8fafc",
  borderRadius: "10px",
  padding: "6px 12px",
  border: "1px solid #e2e8f0",
  transition: "all 0.2s ease-in-out",
  "&:focus-within": {
    borderColor: colors.primary,
    backgroundColor: "#ffffff",
    boxShadow: `0 0 0 3px ${colors.primaryLight}`,
  },
}));

export const StyledInputBase = styled(InputBase)({
  marginLeft: "8px",
  flex: 1,
  fontSize: "0.85rem",
  color: "#1e293b",
});

export const StyledList = styled(List)({
  overflowY: "auto",
  overflowX: "hidden",
  flex: 1,
  padding: "12px",
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f5f9",
    borderRadius: "3px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#cbd5e1",
    borderRadius: "3px",
    "&:hover": {
      background: colors.primary,
    },
  },
});

export const StyledListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "hasClickHandler",
})(({ theme, isSelected, hasClickHandler }) => ({
  cursor: hasClickHandler ? "pointer" : "default",
  borderRadius: "12px",
  marginBottom: "8px",
  padding: "12px 14px",
  backgroundColor: isSelected ? colors.primaryLight : "#ffffff",
  border: isSelected
    ? `1.5px solid ${colors.primaryLightBorder}`
    : "1px solid #e2e8f0",
  borderLeft: isSelected ? `4px solid ${colors.primary}` : "1px solid #e2e8f0",
  transition: "all 0.2s ease-in-out",
  boxShadow: isSelected
    ? "0 4px 12px rgba(127, 29, 29, 0.08)"
    : "0 1px 3px rgba(0,0,0,0.02)",
  "&:hover": {
    backgroundColor: hasClickHandler
      ? isSelected
        ? colors.primaryLight
        : "#f8fafc"
      : "inherit",
    transform: hasClickHandler ? "translateY(-1px)" : "none",
    boxShadow: hasClickHandler
      ? "0 4px 12px rgba(0, 0, 0, 0.06)"
      : "none",
    borderColor: isSelected ? colors.primaryLightBorder : colors.primaryLightBorder,
  },
}));

export const StyledAvatar = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== "hasProfilePic",
})(({ theme, hasProfilePic }) => ({
  width: 42,
  height: 42,
  bgcolor: !hasProfilePic ? colors.primary : "transparent",
  fontWeight: 600,
  fontSize: "0.95rem",
  boxShadow: !hasProfilePic ? "0 2px 6px rgba(127, 29, 29, 0.2)" : "none",
}));

export const StyledListItemText = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})(({ theme, isSelected }) => ({
  margin: 0,
  "& .MuiListItemText-primary": {
    fontWeight: isSelected ? 600 : 500,
    color: isSelected ? colors.primary : "#1e293b",
    fontSize: "0.9rem",
    lineHeight: 1.3,
  },
  "& .MuiListItemText-secondary": {
    color: "#64748b",
    fontSize: "0.78rem",
    marginTop: "2px",
  },
}));

export const SkeletonListItem = styled(ListItem)({
  alignItems: "flex-start",
  padding: "12px 14px",
  marginBottom: "8px",
  borderRadius: "12px",
  backgroundColor: "#ffffff",
  border: "1px solid #e2e8f0",
});

